import { Api } from '../../services/http/Api';
import { doGet } from '../../services/http/httpHelper';

type DoGetError = {
    httpStatus: number;
    body?: unknown;
};

type GetUserByEmailResponse = {
    name?: string;
};

export class UserDataSource {
    async getOperators() {
        const result = (await new Api().fetch('/users/operators')) as Array<{
            name: string;
        }>;
        return result;
    }

    async getUserNameByEmail(email: string): Promise<string> {
        const safeEmail = String(email ?? '').trim();
        if (!safeEmail) return '';

        const resp = (await doGet(
            `/users/email/${encodeURIComponent(safeEmail)}`
        )) as GetUserByEmailResponse | DoGetError;

        if ('httpStatus' in resp && resp.httpStatus !== 200) {
            return '';
        }

        return String((resp as GetUserByEmailResponse)?.name ?? '').trim();
    }
}
